import searchIcon from '~/images/icons/search/search-icon.svg';
import store from '~/javascripts/store.js';
import { useState } from 'react';

const SearchBar = () => {
  const [searchValue, setSearchValue] = useState('');
  const { isSubmitting } = store.campaignSearch;

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    store.campaignSearch.searchInput = searchValue;
    store.campaignSearch.page = 1;
    if (store.campaignSearch.parentCampaignId) {
      store.campaignSearch.fetchChildCampaigns();
    } else {
      store.campaignSearch.fetchCampaigns();
    }
  };

  return (
    <form
      className='search-bar flex flex-col lg-flex-row lg-justify-center items-center self-stretch gap-4 lg-gap-0 pb-10'
      onSubmit={handleSearchSubmit}
    >
      <div className='search-form-query-container h-14 max-w-xs lg-max-w-md shrink-0 w-full flex items-center px-2 gap-2 rounded border border-solid border-cw-grey-900 bg-cw-white'>
        <div className='search-form-query-wrapper flex items-center gap-2'>
          <img
            alt='search icon'
            className='search-icon shrink-0 w-5 h-5'
            src={searchIcon}
          />
          <input
            className='search-form-query body-m border-none'
            id='searchQuery'
            label='false'
            name='search[query]'
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder='Search for a campaign'
            type='text'
            value={searchValue}
          />
        </div>
      </div>
      <button
        className='search-button button button--cw-yellow lg--ml-px h-14 max-w-xs text-cw-black border border-solid w-full'
        disabled={isSubmitting}
        name='commit'
        type='submit'
        value='search'
      >
        Search
      </button>
    </form>
  );
};

export default SearchBar;
